import * as _ from 'lodash';
import { DataProxy } from 'apollo-cache';

import DeviceState from '@/interfaces/DeviceState';
import { FloorLightsWithCurrentState } from '@/queries/floor';

export class PilotingEventHandler {

  private floorId: string;
  private dataProxy: DataProxy;

  private batch: Map<string, DeviceState> = new Map();
  private writeChangesThrottled: () => void;

  constructor(floorId: string, dataProxy: DataProxy) {
    this.floorId = floorId;
    this.dataProxy = dataProxy;
    this.writeChangesThrottled = _.throttle(
      async () => {
        const batchToWrite = new Map(this.batch);
        this.batch.clear();
        await this.writeBatch(batchToWrite);
      },
      2000,
      {
        leading: false,
      },
    );
  }

  updateCurrentStateInCache(lightId: string, state: DeviceState) {
    this.batch.set(lightId, state);
    this.writeChangesThrottled();
  }

  private async writeBatch(batchToWrite: Map<string, DeviceState>) {
    const query = FloorLightsWithCurrentState.query;
    const variables: FloorLightsWithCurrentState.VariablesDefinition = {
      floorId: this.floorId,
    };
    const data = this.dataProxy.readQuery<FloorLightsWithCurrentState.ResultDefinition>({
      query,
      variables,
    });
    if (data == undefined) {
      return;
    }
    data.floor.lights.forEach(
      (light) => {
        const newState = batchToWrite.get(light.id);
        if (newState != undefined) {
          light.currentState = newState;
        }
      },
    );
    this.dataProxy.writeQuery({
      query,
      variables,
      data,
    });
  }

}
